jQuery(document).ready(function($) {
    var sticky;
    var adminBarHeight = 0;
    var headerHeight = $('.page-header').outerHeight();
    if ($('#wpadminbar').length)
        adminBarHeight = $('#wpadminbar').outerHeight();
    headerHeight += $('#wpadminbar').outerHeight();
    if ($('.page-header').hasClass('with-banner')) {
        var helperElem = $('<div class="helper-elem">');
        $('.page-header').before(helperElem);
        helperElem.css({
            height: $('.page-header').outerHeight(),
            display: 'none'
        });
        new Waypoint({
            element: $('#main')[0],
            offset: -1 * (190 + adminBarHeight),
            handler: function(direction) {
                if (direction == 'down')
                {
                    helperElem.css('display','block');
                    $('.page-header').css('opacity',0).addClass('stuck').animate({opacity: 1},500);
                }
            }
        });
        new Waypoint({
            element: $('#main')[0],
            offset: -1 * (90 + adminBarHeight),
            handler: function(direction) {
                if (direction == 'up')
                    $('.page-header').animate({
                        opacity: 0
                    }, 500, function() {
                        helperElem.css('display','none');
                        $(this).removeClass('stuck').css('opacity',1);
                    });
            }
        });
    }
    else {
        sticky = new Waypoint.Sticky({
            element: $('.page-header')[0],
            offset: 100
        });
    }

    var mediaQuery = window.matchMedia("(prefers-reduced-motion: reduce)");
    var timeout;
    var $menu = $();
    $(document).on('mouseover','.menu-item-has-children',function() {
        $(this).attr('aria-expanded',true);
        $menu = $(this);
        clearTimeout(timeout);
    }).on('mouseover','.page-header',function() {
        clearTimeout(timeout);
    }).on('mouseout','.page-header',function() {
        clearTimeout(timeout);
        timeout = setTimeout(function() {
            $menu.removeAttr('aria-expanded');
        },1000);
    }).on('click','a[href*="#"]',function(e) {
        var href = $(this).attr('href');
        var headerHeight = $('.page-header').outerHeight();
        var adminBarHeight = 0;
        if ($('#wpadminbar').length) {
            headerHeight += $('#wpadminbar').outerHeight();
            adminBarHeight += $('#wpadminbar').outerHeight();
        }
        if ($(this).data('bs-toggle') || $(this).data('toggle'))
            return true;
        if (href !== '#' && href !== '#0')
        {
            if (
                location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname
            ) {
                var target = $(this.hash);
                target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
                if (target.length) {
                    // Only prevent default if animation is actually gonna happen
                    e.preventDefault();
                    var time = 500;
                    if (mediaQuery.matches) {
                        $('html,body').scrollTop(target.offset().top - (headerHeight - 5));
                        var $target = $(target);
                        $target.focus();
                        if ($target.is(":focus")) { // Checking if the target was focused
                            return false;
                        } else {
                            $target.attr('tabindex','-1'); // Adding tabindex for elements not focusable
                            $target.focus(); // Set focus again
                        }
                    }
                    else
                    {
                        $('html, body').animate({
                            scrollTop: target.offset().top - (headerHeight - 5)
                        }, 500, function() {
                            // Callback after animation
                            // Must change focus!
                            var $target = $(target);
                            $target.focus();
                            if ($target.is(":focus")) { // Checking if the target was focused
                                return false;
                            } else {
                                $target.attr('tabindex','-1'); // Adding tabindex for elements not focusable
                                $target.focus(); // Set focus again
                            }
                        });
                    }
                }
            }
        }
    });

    function checkBandVisibility() {
        var bottom_of_screen = $(window).scrollTop() + $(window).innerHeight();
        var top_of_screen = $(window).scrollTop();
        $('.band, .vacancy-col, .news-card, .cta-card, .quote, .bio-photo-wrap').each(function () {
            var top_of_element = $(this).offset().top;
            var bottom_of_element = $(this).offset().top + $(this).outerHeight();

            if (bottom_of_screen > top_of_element && top_of_screen < bottom_of_element) {
                // the element is visible, do something
                $(this).addClass('in-viewport');
                $(this).removeClass('below-viewport');
                $(this).removeClass('above-viewport');
            } else if (bottom_of_screen > top_of_element) {
                // scrolled past it
                $(this).addClass('above-viewport');
                $(this).removeClass('in-viewport');
                $(this).removeClass('below-viewport');
            } else {
                // not scrolled to
                $(this).addClass('below-viewport');
                $(this).removeClass('in-viewport');
                $(this).removeClass('above-viewport');
            }
        });
    }
    checkBandVisibility();
    $(window).on('scroll', checkBandVisibility);
});